// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PolicyTemplate_updatedAt__yIXiy {
  font-size: 12.5px;
  color: #6B7280;
}

.PolicyTemplate_contentPreview__-n3D5 {
  font-size: 13px;
  color: #374151;
  max-width: 360px;
}

.PolicyTemplate_statusBadgeDraft__VXARj {
  display: inline-flex;
  align-items: center;
  padding: 3px 12px;
  border-radius: 20px;
  background: #FDEEDD;
  color: #F7941D;
  font-size: 12px;
  font-weight: 700;
}

.PolicyTemplate_statusSelect__kEuBt {
  padding: 5px 10px;
  border-radius: 8px;
  border: 1px solid #E5E7EB;
  font-size: 12px;
  font-weight: 700;
  background: #ffffff;
  cursor: pointer;
}
.PolicyTemplate_statusSelect__kEuBt:focus {
  outline: none;
  border-color: #4c2fb3;
}

.PolicyTemplate_filterRow__xjYss {
  display: flex;
  align-items: center;
  gap: 8px;
}

.PolicyTemplate_varsCount__N5r-M {
  font-size: 12px;
  color: #6B7280;
}

.PolicyTemplate_titleCell__aCsuI {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.PolicyTemplate_titleSub__PX4JN {
  font-size: 11.5px;
  color: #9CA3AF;
}

/* =========================================================
   Add / Edit form
   ========================================================= */
.PolicyTemplate_formGrid__jpM3s {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  max-width: 900px;
}

.PolicyTemplate_editorField__uKq8l {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.PolicyTemplate_tokenHint__ggNqz {
  font-size: 12px;
  color: #6B7280;
}

/* =========================================================
   Sample variables editor
   ========================================================= */
.PolicyTemplate_varsBlock__-FSMI {
  border: 1px solid #E7E9F1;
  border-radius: 14px;
  padding: 16px 18px;
  background: #FAFAFC;
}

.PolicyTemplate_varsHeader__edUhh {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.PolicyTemplate_varsTitle__24\\+y\\+ {
  font-size: 13px;
  font-weight: 700;
  color: #1F2430;
}

.PolicyTemplate_varsHint__-FRHB {
  font-size: 12px;
  color: #6B7280;
  margin: -6px 0 12px;
}

.PolicyTemplate_addVarBtn__7wWUa {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #F5F3FE;
  color: #4c2fb3;
  border: none;
  border-radius: 8px;
  font-size: 12.5px;
  font-weight: 700;
  padding: 7px 14px;
  cursor: pointer;
  transition: background 0.15s ease;
}
.PolicyTemplate_addVarBtn__7wWUa:hover {
  background: #E7DEFB;
}

.PolicyTemplate_varRow__1-ZlM {
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: 10px;
  margin-bottom: 8px;
  align-items: center;
}

.PolicyTemplate_varInput__pZFVL {
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #E5E7EB;
  font-size: 13px;
  background: #ffffff;
}
.PolicyTemplate_varInput__pZFVL:focus {
  outline: none;
  border-color: #4c2fb3;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);
}

.PolicyTemplate_varKeyInput__b3Xde {
  font-family: 'Courier New', monospace;
  font-size: 12.5px;
}

.PolicyTemplate_removeVarBtn__HPUU8 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  background: #FDEDED;
  color: #DC2626;
  cursor: pointer;
  flex-shrink: 0;
}
.PolicyTemplate_removeVarBtn__HPUU8:hover {
  background: #FBD5D5;
}

.PolicyTemplate_previewToggleRow__HD50- {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.PolicyTemplate_previewToggleBtn__Fvx2X {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #F5F3FE;
  color: #4c2fb3;
  border: none;
  border-radius: 10px;
  font-size: 12.5px;
  font-weight: 700;
  padding: 8px 16px;
  cursor: pointer;
  transition: background 0.15s ease;
}
.PolicyTemplate_previewToggleBtn__Fvx2X:hover {
  background: #E7DEFB;
}

.PolicyTemplate_previewPane__GlTFA {
  border: 1px solid #E7E9F1;
  border-radius: 14px;
  overflow: hidden;
  background: #ffffff;
}

.PolicyTemplate_previewPaneHeader__0TpDS {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 18px;
  background: linear-gradient(120deg, #2b1657 0%, #4c2fb3 55%, #7c5cfc 100%);
  color: #ffffff;
  font-size: 12.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.PolicyTemplate_previewPaneBody__iMzJu {
  padding: 18px 22px;
  font-size: 13.5px;
  line-height: 1.7;
  color: #1F2430;
  max-height: 340px;
  overflow-y: auto;
}
.PolicyTemplate_previewPaneBody__iMzJu ul,
.PolicyTemplate_previewPaneBody__iMzJu ol {
  padding-left: 22px;
  margin: 6px 0;
}
.PolicyTemplate_previewPaneBody__iMzJu p {
  margin: 0 0 8px;
}
.PolicyTemplate_previewPaneBody__iMzJu:empty::before {
  content: "Nothing to preview yet.";
  color: #9CA3AF;
}

/* =========================================================
   Preview modal (list page)
   ========================================================= */
.PolicyTemplate_modalBox__RLhpY {
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
}

.PolicyTemplate_modalHeader__fnvMZ {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 22px;
  background: linear-gradient(120deg, #2b1657 0%, #4c2fb3 55%, #7c5cfc 100%);
  flex-shrink: 0;
}

.PolicyTemplate_modalTitle__8hG7O {
  font-family: 'Sora', 'Inter', sans-serif;
  font-size: 14.5px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
}

.PolicyTemplate_modalClose__-9sEc {
  color: #ffffff;
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
}

.PolicyTemplate_modalBody__7MjKa {
  padding: 20px 22px;
  overflow-y: auto;
  font-size: 13.5px;
  line-height: 1.7;
  color: #1F2430;
}
.PolicyTemplate_modalBody__7MjKa ul,
.PolicyTemplate_modalBody__7MjKa ol {
  padding-left: 22px;
  margin: 6px 0;
}
.PolicyTemplate_modalBody__7MjKa p {
  margin: 0 0 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/PolicyTemplate/PolicyTemplate.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;8DAE8D;AAC9D;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,0EAA0E;EAC1E,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;;8DAE8D;AAC9D;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,0EAA0E;EAC1E,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,eAAe;AACjB","sourcesContent":[".updatedAt {\n  font-size: 12.5px;\n  color: #6B7280;\n}\n\n.contentPreview {\n  font-size: 13px;\n  color: #374151;\n  max-width: 360px;\n}\n\n.statusBadgeDraft {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 12px;\n  border-radius: 20px;\n  background: #FDEEDD;\n  color: #F7941D;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.statusSelect {\n  padding: 5px 10px;\n  border-radius: 8px;\n  border: 1px solid #E5E7EB;\n  font-size: 12px;\n  font-weight: 700;\n  background: #ffffff;\n  cursor: pointer;\n}\n.statusSelect:focus {\n  outline: none;\n  border-color: #4c2fb3;\n}\n\n.filterRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.varsCount {\n  font-size: 12px;\n  color: #6B7280;\n}\n\n.titleCell {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.titleSub {\n  font-size: 11.5px;\n  color: #9CA3AF;\n}\n\n/* =========================================================\n   Add / Edit form\n   ========================================================= */\n.formGrid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 20px;\n  max-width: 900px;\n}\n\n.editorField {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.tokenHint {\n  font-size: 12px;\n  color: #6B7280;\n}\n\n/* =========================================================\n   Sample variables editor\n   ========================================================= */\n.varsBlock {\n  border: 1px solid #E7E9F1;\n  border-radius: 14px;\n  padding: 16px 18px;\n  background: #FAFAFC;\n}\n\n.varsHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.varsTitle {\n  font-size: 13px;\n  font-weight: 700;\n  color: #1F2430;\n}\n\n.varsHint {\n  font-size: 12px;\n  color: #6B7280;\n  margin: -6px 0 12px;\n}\n\n.addVarBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: #F5F3FE;\n  color: #4c2fb3;\n  border: none;\n  border-radius: 8px;\n  font-size: 12.5px;\n  font-weight: 700;\n  padding: 7px 14px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n.addVarBtn:hover {\n  background: #E7DEFB;\n}\n\n.varRow {\n  display: grid;\n  grid-template-columns: 1fr 1fr auto;\n  gap: 10px;\n  margin-bottom: 8px;\n  align-items: center;\n}\n\n.varInput {\n  padding: 8px 12px;\n  border-radius: 8px;\n  border: 1px solid #E5E7EB;\n  font-size: 13px;\n  background: #ffffff;\n}\n.varInput:focus {\n  outline: none;\n  border-color: #4c2fb3;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);\n}\n\n.varKeyInput {\n  font-family: 'Courier New', monospace;\n  font-size: 12.5px;\n}\n\n.removeVarBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  border: none;\n  background: #FDEDED;\n  color: #DC2626;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n.removeVarBtn:hover {\n  background: #FBD5D5;\n}\n\n.previewToggleRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.previewToggleBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: #F5F3FE;\n  color: #4c2fb3;\n  border: none;\n  border-radius: 10px;\n  font-size: 12.5px;\n  font-weight: 700;\n  padding: 8px 16px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n.previewToggleBtn:hover {\n  background: #E7DEFB;\n}\n\n.previewPane {\n  border: 1px solid #E7E9F1;\n  border-radius: 14px;\n  overflow: hidden;\n  background: #ffffff;\n}\n\n.previewPaneHeader {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 18px;\n  background: linear-gradient(120deg, #2b1657 0%, #4c2fb3 55%, #7c5cfc 100%);\n  color: #ffffff;\n  font-size: 12.5px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.previewPaneBody {\n  padding: 18px 22px;\n  font-size: 13.5px;\n  line-height: 1.7;\n  color: #1F2430;\n  max-height: 340px;\n  overflow-y: auto;\n}\n.previewPaneBody ul,\n.previewPaneBody ol {\n  padding-left: 22px;\n  margin: 6px 0;\n}\n.previewPaneBody p {\n  margin: 0 0 8px;\n}\n.previewPaneBody:empty::before {\n  content: \"Nothing to preview yet.\";\n  color: #9CA3AF;\n}\n\n/* =========================================================\n   Preview modal (list page)\n   ========================================================= */\n.modalBox {\n  background: #ffffff;\n  border-radius: 16px;\n  overflow: hidden;\n  max-height: 85vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.modalHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 18px 22px;\n  background: linear-gradient(120deg, #2b1657 0%, #4c2fb3 55%, #7c5cfc 100%);\n  flex-shrink: 0;\n}\n\n.modalTitle {\n  font-family: 'Sora', 'Inter', sans-serif;\n  font-size: 14.5px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0;\n}\n\n.modalClose {\n  color: #ffffff;\n  cursor: pointer;\n  display: flex;\n  flex-shrink: 0;\n}\n\n.modalBody {\n  padding: 20px 22px;\n  overflow-y: auto;\n  font-size: 13.5px;\n  line-height: 1.7;\n  color: #1F2430;\n}\n.modalBody ul,\n.modalBody ol {\n  padding-left: 22px;\n  margin: 6px 0;\n}\n.modalBody p {\n  margin: 0 0 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"updatedAt": `PolicyTemplate_updatedAt__yIXiy`,
	"contentPreview": `PolicyTemplate_contentPreview__-n3D5`,
	"statusBadgeDraft": `PolicyTemplate_statusBadgeDraft__VXARj`,
	"statusSelect": `PolicyTemplate_statusSelect__kEuBt`,
	"filterRow": `PolicyTemplate_filterRow__xjYss`,
	"varsCount": `PolicyTemplate_varsCount__N5r-M`,
	"titleCell": `PolicyTemplate_titleCell__aCsuI`,
	"titleSub": `PolicyTemplate_titleSub__PX4JN`,
	"formGrid": `PolicyTemplate_formGrid__jpM3s`,
	"editorField": `PolicyTemplate_editorField__uKq8l`,
	"tokenHint": `PolicyTemplate_tokenHint__ggNqz`,
	"varsBlock": `PolicyTemplate_varsBlock__-FSMI`,
	"varsHeader": `PolicyTemplate_varsHeader__edUhh`,
	"varsTitle": `PolicyTemplate_varsTitle__24+y+`,
	"varsHint": `PolicyTemplate_varsHint__-FRHB`,
	"addVarBtn": `PolicyTemplate_addVarBtn__7wWUa`,
	"varRow": `PolicyTemplate_varRow__1-ZlM`,
	"varInput": `PolicyTemplate_varInput__pZFVL`,
	"varKeyInput": `PolicyTemplate_varKeyInput__b3Xde`,
	"removeVarBtn": `PolicyTemplate_removeVarBtn__HPUU8`,
	"previewToggleRow": `PolicyTemplate_previewToggleRow__HD50-`,
	"previewToggleBtn": `PolicyTemplate_previewToggleBtn__Fvx2X`,
	"previewPane": `PolicyTemplate_previewPane__GlTFA`,
	"previewPaneHeader": `PolicyTemplate_previewPaneHeader__0TpDS`,
	"previewPaneBody": `PolicyTemplate_previewPaneBody__iMzJu`,
	"modalBox": `PolicyTemplate_modalBox__RLhpY`,
	"modalHeader": `PolicyTemplate_modalHeader__fnvMZ`,
	"modalTitle": `PolicyTemplate_modalTitle__8hG7O`,
	"modalClose": `PolicyTemplate_modalClose__-9sEc`,
	"modalBody": `PolicyTemplate_modalBody__7MjKa`
};
export default ___CSS_LOADER_EXPORT___;
